export const categorizeSkillSuggestions = (skillNudges = []) => {
  if (!skillNudges || skillNudges.length === 0) {
    return {
      userDefinedSkills: [],
      systemLevelSkills: []
    };
  }

  return {
    userDefinedSkills: skillNudges.filter(nudge => !nudge.skillUri),
    systemLevelSkills: skillNudges.filter(nudge => Boolean(nudge.skillUri))
  };
};

export const getUserDefinedSkillSuggestions = (skillNudges = []) =>
  skillNudges.filter(nudge => !nudge.skillUri);

export const getSystemLevelSkillSuggestions = (skillNudges = []) =>
  skillNudges.filter(nudge => Boolean(nudge.skillUri));

export default categorizeSkillSuggestions;
